import { useMemo } from 'react';
import { ReactComponent as FingerPrintIconRed } from '../../../assets/images/icons/fingerprint_red.svg';
import { ReactComponent as FingerPrintIconGreen } from '../../../assets/images/icons/fingerprint_green.svg';
import '../../prescription/transitions.css';
import { Box } from '../../../components/UI-CHAKRA/Box';
import { Text } from '../../../components/UI-CHAKRA/Text';
import { Flex } from '../../../components/UI-CHAKRA/Flex';
import { AnimatePresence } from 'framer-motion';
import { BounceFadeMotionBox } from '../../../components/Motion/BounceFadeMotionBox';

interface PrescriptionSignedNotificationProps {
  isDigitalCertificateSelected: boolean;
  doesPrescriptionHasSigningWarning: boolean;
}

export function PrescriptionSignedNotification(props: PrescriptionSignedNotificationProps) {
  const { isDigitalCertificateSelected } = props;

  const SignedCard = useMemo(() => {
    if (!isDigitalCertificateSelected) return;

    return (
      <Flex
        width={'100%'}
        justifyContent={'center'}
        alignItems={'center'}
        bg={'#fff'}
        border={'1px solid'}
        borderColor={'success.main'}
        borderRadius={'50px'}
        p={'7px 10px'}
      >
        <FingerPrintIconGreen style={{ width: '20px', height: '20px', marginRight: '7px' }} />
        <Text fontWeight={'700'} fontSize={'13px'} color={'success.main'} lineHeight={'15px'}>
          Assinada digitalmente
        </Text>
      </Flex>
    );
  }, [isDigitalCertificateSelected]);

  return (
    <Box>
      <AnimatePresence>
        {isDigitalCertificateSelected && <BounceFadeMotionBox>{SignedCard}</BounceFadeMotionBox>}
      </AnimatePresence>

      <AnimatePresence>
        {!isDigitalCertificateSelected && (
          <BounceFadeMotionBox>
            <Box borderRadius={'17px'} border={'1px solid'} borderColor={'error.main'} padding={'5px'} bgColor="white">
              <Flex justifyContent={'center'} alignItems={'center'}>
                <FingerPrintIconRed style={{ width: '20px', height: '20px', marginRight: '7px' }} />
                <Text fontWeight={700} fontSize={'12px'} color={'error.main'} textAlign={'center'}>
                  Não será assinada digitalmente
                </Text>
              </Flex>
            </Box>
          </BounceFadeMotionBox>
        )}
      </AnimatePresence>
    </Box>
  );
}
